import { useState, useEffect } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { showToast } from "utils/swalToast"

// MUI + Dashboard
import Card from "@mui/material/Card"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import MDInput from "components/MDInput"
import MDButton from "components/MDButton"
import BasicLayout from "layouts/authentication/components/BasicLayout"
import defaultBgImage from "assets/images/background.webp"
import defaultLogo from "assets/images/logo.svg"
import useBrandLogo from "hooks/useBrandLogo"
import useBackgroundImage from "hooks/useBackgroundImage"
import config from "config"

function ResetPassword() {
  const brandLogo = useBrandLogo(defaultLogo)
  const bgImage = useBackgroundImage(defaultBgImage)
  const [searchParams] = useSearchParams()
  const token = searchParams.get("token")

  const [password, setPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [error, setError] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    if (!token) {
      setError("Token inválido o ausente.")
    }
  }, [token])

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!password || !confirmPassword) {
      setError("Todos los campos son obligatorios.")
      return
    }
    if (password !== confirmPassword) {
      setError("Las contraseñas no coinciden.")
      return
    }

    setIsSubmitting(true)
    setError("")

    try {
      const response = await fetch(`${config.api.baseURL}/security-tokens/verify`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
        },
        body: JSON.stringify({ token, password }),
      })

      if (response.ok) {
        await showToast({ title: "Contraseña actualizada con éxito", icon: "success" })
        navigate("/authentication/sign-in")
      } else {
        const errorText = await response.text()
        setError(errorText || "No se pudo actualizar la contraseña.")
      }
    } catch (err) {
      console.error(err)
      setError("Error de red. Intente nuevamente.")
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <BasicLayout image={bgImage}>
      <MDBox display="flex" justifyContent="center" alignItems="center" height="100vh">
        <Card style={{ width: "600px", border: "1px solid #DAD9D9" }}>
          <MDBox
            variant="gradient"
            bgColor="primary"
            borderRadius="lg"
            coloredShadow="info"
            mx={2}
            mt={-3}
            p={2}
            mb={1}
            textAlign="center"
          >
            <MDBox component="img" src={brandLogo} alt="logo" width="40%" mt={1} />
            <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
              Nueva contraseña
            </MDTypography>
          </MDBox>
          <MDBox pt={4} pb={3} px={3}>
            <form onSubmit={handleSubmit}>
              <MDBox mb={2}>
                <MDInput
                  type="password"
                  label="Nueva contraseña"
                  fullWidth
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </MDBox>
              <MDBox mb={2}>
                <MDInput
                  type="password"
                  label="Confirmar contraseña"
                  fullWidth
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </MDBox>
              <MDBox mt={2}>
                <MDButton
                  variant="gradient"
                  color="primary"
                  type="submit"
                  fullWidth
                  disabled={isSubmitting || !token}
                >
                  {isSubmitting ? "Enviando..." : "Guardar contraseña"}
                </MDButton>
              </MDBox>
              {error && (
                <MDBox mt={2} textAlign="center">
                  <MDTypography variant="caption" color="error">
                    {error}
                  </MDTypography>
                </MDBox>
              )}
            </form>
          </MDBox>
        </Card>
      </MDBox>
    </BasicLayout>
  )
}

export default ResetPassword


